<template>
  <div class="hero">
    <div class="image-box">
      <img alt="Frogero App" id="app-mock" src="@/assets/home/frogero_app_mock_small.webp">
    </div>
    <div class="text-box">
      <h1 class="break">Outside the classrom speaking trainer for <br/> your students</h1>
      <h1 class="no-break">Outside the classrom speaking trainer for your students</h1>
      <ul>
        <li>choose from provided interactive dialogues or create your own</li>
        <li>let students practice and record themselves</li>
        <li>review students' recordings</li>
      </ul>
      <div class="button-row">
        <button class="free-account" @click="onSignup">
          <span>Free account</span>
        </button>
        <button class="see-examples" @click="scrollDialogs">
          <span>See examples</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Hero',
  methods: {
    onSignup() {
      this.$emit('onSignup');
    },
    scrollDialogs() {
      this.$emit('scrollDialogs');
    }
  }
}
</script>

<style lang="scss" scoped>
.hero {
  width: 100%;
  height: 32rem;
  background-color: #006f6f;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 900px) {
    height: 25rem;
  }
  @media (max-width: 800px) {
    flex-direction: column;
    height: auto;
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
}

.image-box {
  width: auto;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: -3rem;
  @media (max-width: 1100px) {
    margin-left: 0rem;
  }

  #app-mock {
    width: 15rem;
    @media (max-width: 1000px) {
      width: 13rem;
    }
    @media (max-width: 900px) {
      width: 11rem;
    }
  }
}

.text-box {
  width: auto;
  height: auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 5.5rem;
  @media (max-width: 1050px) {
    margin-left: 3rem;
  }
  @media (max-width: 900px) {
    margin-left: 2rem;
  }
  @media (max-width: 800px) {
    margin-left: 0rem;
    margin-top: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }
  @media (max-width: 620px) {
    margin-top: 2rem;
  }

  h1 {
    color: white;
    line-height: 3rem;
    @media (max-width: 1000px) {
      font-size: 1.6rem;
      line-height: 2.5rem;
    }
    @media (max-width: 900px) {
      font-size: 1.4rem;
      line-height: 2.5rem;
    }
    @media (max-width: 620px) {
      font-size: 1.3rem;
    }
  }

  .break {
    display: flex;
    @media (max-width: 800px) {
      display: none;
    }
  }

  .no-break {
    display: none;
    @media (max-width: 800px) {
      display: flex;
    }
  }

  ul {
    margin-top: 1.5rem;
    padding-left: 1.2rem;
    color: white;
    font-size: 1.3rem;
    line-height: 2rem;
    @media (max-width: 1000px) {
      font-size: 1.2rem;
      line-height: 2rem;
    }
    @media (max-width: 900px) {
      font-size: 1.1rem;
      line-height: 2rem;
      margin-top: 1rem;
    }
    @media (max-width: 620px) {
      font-size: 1rem;
    }
  }

  .button-row {
    width: 100%;
    height: auto;
    display: flex;
    margin-top: 2.5rem;

    @media (max-width: 1000px) {
      margin-top: 2rem;
    }
    @media (max-width: 900px) {
      margin-top: 1.8rem;
    }
    @media (max-width: 800px) {
      justify-content: flex-end;
    }
    @media (max-width: 400px) {
      justify-content: space-between;
    }

    button {
      height: 2.5rem;
      background: none;
      border: none;
      outline: none;
      color: white;
      font-weight: bold;
      font-size: 1.2rem;
      padding-left: 1.3rem;
      padding-right: 1.3rem;
      border-radius: 0.2rem;
      transition: 0.3s;
      @media (max-width: 900px) {
        font-size: 1.1rem;
        padding-left: 1.2rem;
        padding-right: 1.2rem;
      }
      @media (max-width: 400px) {
        font-size: 1rem;
        padding-left: 1.1rem;
        padding-right: 1.1rem;
      }
      @media (max-width: 350px) {
        font-size: 0.9rem;
        padding-left: 0.8rem;
        padding-right: 0.8rem;
      }

      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }

    .free-account {
      background-color: #e6c17d;
    }

    .see-examples {
      background-color: #11B6A5;
      margin-left: 1.5rem;
      @media (max-width: 900px) {
        margin-left: 1.2rem;
      }
    }
  }
}
</style>